<div class="flex flex-row flex-wrap justify-between items-center flex-1-0-100">
  <button *ngIf="item.cells[fieldDefinition.key]?.displayText !== 'N/A'"
          mat-button class="grid-button"
          particleAnalytics
          analyticsCategory="action-type-cell-viewer"
          analyticsAction="action-button"
          (click)="onSelectActionType()">
    {{item.cells[fieldDefinition.key]?.displayText ? item.cells[fieldDefinition.key]?.displayText : 'Generate'}}
  </button>

  <div *ngIf="item.cells[fieldDefinition.key]?.displayText === 'N/A'">
    {{item.cells[fieldDefinition.key]?.displayText}}
  </div>

</div>
